export default __webpack_public_path__ + "static/media/112.720317d2.gif";